import LoadingComponent from './loading.vue';
import vLoading from './loadingDirective';

export const Loading = {
    install(app: any) {
        app.directive('loading', vLoading);
    },
    directive: vLoading,
    component: LoadingComponent,
};

export default Loading;
